export default {
  SET_IS_CATEGORIES_LOADING: 'setIsCategoriesLoading',
  SET_CATEGORIES: 'setCategories',
  SET_SELECTED_SCENARIO: 'setSelectedScenario',
  SET_MODEL_OPTIONS: 'setModelOptions',
  SET_SCENARIO_RUNS: 'setScenarioRuns',
};
